import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { verifyCourseEnrolment } from '../../../store/courses/actions';

const VerifyCourseEnrolmentPage = ({
  success,
  error,
  verify,
  location: { search },
  match: { params: { courseId } },
}) => {
  useEffect(() => {
    const { id } = qs.parse(search);

    verify(courseId, id);
  }, [verify, courseId, search]);

  return (
    <div className="page-course-enrolment-verify">
      {success && <Alert color="success">Success - user has been enroled.</Alert>}
      {error && <Alert color="danger">{error.message}</Alert>}
    </div>
  );
};

VerifyCourseEnrolmentPage.propTypes = {
  success: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  verify: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      courseId: PropTypes.string,
    }),
  }).isRequired,
};

VerifyCourseEnrolmentPage.defaultProps = {
  success: null,
  error: null,
};

function mapStateToProps({ courses: { verify: { success, error } } }) {
  return { success, error };
}

function mapDispatchToProps(dispatch) {
  return {
    verify: (courseId, userId) => dispatch(verifyCourseEnrolment({ courseId, userId })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyCourseEnrolmentPage);
